import * as React from "react";
import { useEffect, useState } from "react";
import { useAppDataProvider } from "../../dataprovider";
import { useVerifyPermission } from "@airborne/react-admin";

const HealthCheck = props => {
  useVerifyPermission("customroutes", "healthcheck.read");
  const dataProvider = useAppDataProvider();
  const [health, setHealth] = useState("");

  const getHealthCheck = () => {
    dataProvider.getHealthCheck().then((result: any) => {
      const data = result?.data;
      setHealth(JSON.stringify(data));
    });
  };

  useEffect(() => {
    getHealthCheck();
  }, []);

  return <>{health}</>;
};

export default HealthCheck;
